module.exports = __webpack_public_path__ + "static/media/i-tab.e67b1900.png";